<div class="references-table-container m-3">
    <table mat-table [dataSource]="referenceRows()" [trackBy]="trackBy" class="references-table">

        <!-- Selection -->
        <ng-container matColumnDef="_select">
            <th mat-header-cell *matHeaderCellDef class="w-12">
                <mat-checkbox (change)="toggleSelection()" [checked]="isAllSelected()" [indeterminate]="isSelectionIndeterminate()"></mat-checkbox>
            </th>
            <td mat-cell class="checkbox" *matCellDef="let ref; let i = index">
                <mat-checkbox
                        class="selector"
                        color="primary"
                        [checked]="isSelected(i + 1)"
                        (change)="toggleSelectRow(i + 1)"
                ></mat-checkbox>
            </td>
        </ng-container>

        @for (column of referenceGroups(); track column) {
            <ng-container [matColumnDef]="column.name">
                <th mat-header-cell *matHeaderCellDef>{{ column.caption }}</th>
                <td mat-cell *matCellDef="let row; let i = index">
                    <input class="w-full" maxLength="40" matInput type="text" [value]="row[column.name] || ''" (blur)="onFieldBlur(i + 1, column.name, $event)">
                </td>
            </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="referenceColumns()"></tr>
        <tr mat-row *matRowDef="let row; columns: referenceColumns();"></tr>
    </table>
</div>

<div class="references-footer m-3 mt-2 mb-0">
    <button mat-button (click)="addReference()" i18n [disabled]="disableAdd()">Add Reference</button>
    <button mat-button (click)="deleteReferences()" i18n [disabled]="disableDelete()">Delete</button>
</div>
